import format from 'date-fns/format';
import koLocale from 'date-fns/locale/ko';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';

export const formatRegularHourStatus = (regularHoursStatus: string, date: string): string => {
  if (!regularHoursStatus || regularHoursStatus.length === 0) {
    return '';
  }
  const parsedDate = date ? parse(date, 'yyyy-MM-dd', new Date()) : undefined;
  switch (regularHoursStatus) {
    case 'BEFORE':
      return `${parsedDate ? format(parsedDate, 'MM.dd') : ''} 개장전`;
    case 'CONTINUOUS':
      return `${format(new Date(), 'HH:mm')} 장중`;
    case 'CLOSING':
      return `${parsedDate ? format(parsedDate, 'MM.dd') : ''} 장종료`;
    default:
      return '';
  }
};

export const formatCurrentTime = (): string => {
  return format(new Date(), 'MM.dd HH:mm');
};

export const formatNewsTime = (time: string): string => {
  if (time) {
    const parsed = parseISO(time);
    return parsed ? format(parsed, 'yyyy.MM.dd aa HH:mm', { locale: koLocale }) : '';
  }

  return '';
};

// 년, 월(0~11), 일, 시, 분, 초, 밀리초
type UTCDateTimeFormat = [number, number, number?, number?, number?, number?, number?];
type ComparableDate = Date | UTCDateTimeFormat;

const isUTCDateTimeFormat = (target: any): target is UTCDateTimeFormat => {
  return Array.isArray(target) && typeof target[0] === 'number' && typeof target[1] === 'number';
};

const isDate = (target: any): target is Date => {
  return target instanceof Date;
};

const getMilliseconds = (target: any) => {
  if (isUTCDateTimeFormat(target)) {
    return Date.UTC(...target);
  } else if (isDate(target)) {
    return target.getTime();
  } else {
    return -1;
  }
};

export const compareDate = (referenceDate: ComparableDate, targetDate: ComparableDate) => {
  const referenceMilliseconds = getMilliseconds(referenceDate);
  const targetMilliseconds = getMilliseconds(targetDate);

  return targetMilliseconds > referenceMilliseconds;
};
